import { ChatGuest, IChatGuest } from './chat-guest';

export interface IChatRoom {
  id: string;
  fromGuest: IChatGuest;
  toGuests: any[];
  nbUnreadMessages: number;
}

export class ChatRoom {
  static toDto(room: IChatRoom): any {
    return {
      id: room.id,
      fromGuest: ChatGuest.toDto(room.fromGuest),
      toGuests: room.toGuests.map(guest => ChatGuest.toDto(guest)),
      nbUnreadMessages: room.nbUnreadMessages,
    };
  }

  static fromDto(dto: any): IChatRoom {
    return <IChatRoom>{
      id: dto.id,
      fromGuest: ChatGuest.fromDto(dto.fromGuest),
      toGuests: dto.toGuests.map(guestDto => ChatGuest.fromDto(guestDto)),
      nbUnreadMessages: dto.nbUnreadMessages,
    };
  }
}
